export default __webpack_public_path__ + "static/media/manila-1-map.d91354cc.jpg";